export default __webpack_public_path__ + "static/media/23C1B992-E578-4E38-840C-F1DD5EFD15F8.09625dc2.jpeg";